import { credibilityItems } from "@/mocks/home";

function Credibility() {
  return (
    <section id="credibility" className="scroll-mt-24 bg-background-100">
      <div className="mx-auto w-full max-w-7xl px-4 py-12 md:px-6 md:py-20">
        <div className="grid gap-10 lg:grid-cols-[1fr_1fr] lg:items-center">
          <div>
            <p className="mb-2 font-label text-xs uppercase tracking-[0.24em] text-primary-600">
              Credibility Check
            </p>
            <h2 className="font-heading text-3xl font-black leading-snug text-foreground-950 md:text-4xl">
              这个账号
              <span className="text-accent-600">该信几分？</span>
            </h2>
            <p className="mt-4 max-w-xl text-[15px] leading-relaxed text-foreground-600">
              聊“四一爆料是谁”之外，更实际的问题是：一个身份不明的爆料者，其信息能不能采信。把可信度拆成四个维度看，供你做独立判断，而不是替谁站队。
            </p>

            <div className="mt-7 rounded-lg bg-background-50 p-5 ring-1 ring-background-200/70">
              <p className="text-sm font-semibold text-foreground-800">一句话口径</p>
              <p className="mt-2 font-heading text-lg font-bold leading-relaxed text-foreground-950">
                “内容上有料，身份上成谜。”<br />
                <span className="text-accent-700">信内容别信人设，引用需谨慎。</span>
              </p>
            </div>
          </div>

          {/* bars */}
          <div className="space-y-6">
            {credibilityItems.map((item) => {
              const pct = item.score * 20;
              const fill =
                item.score >= 4
                  ? "bg-foreground-950"
                  : item.score >= 3
                    ? "bg-primary-500"
                    : "bg-accent-500";
              const labelTone =
                item.score >= 4 ? "text-foreground-800" : item.score >= 3 ? "text-primary-700" : "text-accent-700";
              return (
                <div key={item.id}>
                  <div className="mb-2 flex items-baseline justify-between gap-3">
                    <span className="text-sm font-semibold text-foreground-900">{item.axis}</span>
                    <span className={"inline-flex items-center gap-1 font-label text-sm font-semibold " + labelTone}>
                      <i className="ri-scales-3-line text-sm"></i>
                      {item.label}
                    </span>
                  </div>
                  <div className="h-2.5 w-full overflow-hidden rounded-full bg-background-200">
                    <div className={"h-full rounded-full " + fill} style={{ width: pct + "%" }}></div>
                  </div>
                  <p className="mt-1.5 text-xs leading-relaxed text-foreground-500">{item.desc}</p>
                </div>
              );
            })}
            <p className="flex items-start gap-2 pt-1 text-xs leading-relaxed text-foreground-500">
              <i className="ri-zoom-in-line mt-0.5 text-accent-600"></i>
              <span>评分区间 1–5，由本站根据公开信息整理的相对印象，非权威评级，仅供参考。</span>
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Credibility;